import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.apiKey.DOC}
  mutation GenerateApiKey(
    $tenantId: ID!
    $zoneId: ID!
    $name: String!
    $expiresAt: AWSDateTime
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        generateApiKey(name: $name, expiresAt: $expiresAt) {
          key
          apiKey {
            ...FragmentApiKey
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.GenerateApiKeyMutation,
    ents.core.admin.ApiKey.Generated,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'generateApiKey',
        graphql.transformers.OUT.custom<
          NonNullable<
            NonNullable<
              NonNullable<
                graphql.schema.GenerateApiKeyMutation['tenant']
              >['zone']
            >['generateApiKey']
          >,
          ents.core.admin.ApiKey.Generated
        >(generated => ({
          apiKey: fragments.apiKey.TRANSFORMER.getEntityFrom(generated.apiKey),
          key: generated.key,
        })),
      ),
    ),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.GenerateApiKeyMutation,
  ents.core.admin.ApiKey.Generated,
  graphql.schema.GenerateApiKeyMutationVariables
>({ query: DOC, transformer: TRANSFORMER })
